import { render, staticRenderFns } from "./VariantPickerPropertySelect.vue?vue&type=template&id=2c530f36&"
import script from "./VariantPickerPropertySelect.vue?vue&type=script&lang=js&"
export * from "./VariantPickerPropertySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports